import styled from '@emotion/styled';

export const ContentWrapper = styled.div`
    .a-button.-without-label .a-button__icon {
        margin: auto;
        padding: 5px;
    }

    .m-table {
        border-collapse: collapse;
        font-size: rem(16px);
        line-height: 1.45;
        width: 100%;

        td,
        th {
            @include text-regular;

            max-width: initial;
            height: 2rem;
            line-height: 0.9rem;
            box-sizing: border-box;
            padding: 0.1rem 1rem 0.1rem 0;
            border: 0;
            border-bottom: 0.06rem;
            border-style: solid;
            border-color: var(--plain__disabled__front__default);

            > .a-icon {
                vertical-align: text-bottom;
            }
        }

        th {
            font-weight: 700;
            white-space: nowrap;
        }

        thead th {
            border-color: var(--plain__enabled__front__default);
        }

        th:first-of-type,
        td:first-of-type {
            padding-left: 1rem;
        }

        th:last-child,
        td:last-child {
            padding-right: 1rem;
        }
    }
`;
